import { memo } from 'react';
import { t, T } from '@ocean-club/dapps/dist/modules/translation/utils'
import { Page, Header, Button } from '@ocean-club/ui'

import { AssetType } from '../../modules/asset/types'
import { locations } from '../../modules/routing/locations'
import { getAssetName } from '../../modules/asset/utils'
import { formatMANA } from '../../lib/mana'
import { Navbar } from '../Navbar'
import { Footer } from '../Footer'
import { Wallet } from '../Wallet'
import { Mana } from '../Mana'
import { AssetProviderPage } from '../AssetProviderPage'
import { AssetAction } from '../AssetAction'
import { Props } from './CancelSalePage.types'
import './CancelSalePage.css'

const CancelSalePage = (props: Props) => {
  const { isLoading, onNavigate, onCancelOrder } = props

  return (
    <>
      <Navbar isFullscreen />
      <Page className="CancelSalePage">
        <Wallet>
          {wallet => (
            <AssetProviderPage type={AssetType.NFT}>
              {(nft, order) => {
                let subtitle
                let isDisabled = false
                const name = getAssetName(nft)
                if (!order) {
                  isDisabled = true
                  subtitle = (
                    <T
                      id="cancel_sale_page.not_for_sale"
                      values={{ name: <b>{name}</b> }}
                    />
                  )
                } else if (order.owner !== wallet.address) {
                  isDisabled = true
                  subtitle = (
                    <T
                      id="cancel_sale_page.invalid_owner"
                      values={{ name: <b>{name}</b> }}
                    />
                  )
                } else {
                  subtitle = (
                    <T
                      id="cancel_sale_page.subtitle"
                      values={{
                        name: <b>{name}</b>,
                        amount: (
                          <Mana inline>
                            {order.contractAddress === 'TMCBfg4XDFTLCZapnwAVHypW2sm9hB3okZ' ? (
                              Number(order.price).toLocaleString()) : formatMANA(order.price)}
                          </Mana>
                        )
                      }}
                    />
                  )
                }
                return (
                  <AssetAction asset={nft}>
                    <Header size="large">{t('cancel_sale_page.title')}</Header>
                    <div className="subtitle">{subtitle}</div>
                    <div className="buttons">
                      <Button
                        onClick={() =>
                          onNavigate(
                            locations.nft(nft.contractAddress, nft.tokenId)
                          )
                        }
                      >
                        {t('global.cancel')}
                      </Button>
                      <Button
                        primary
                        loading={isLoading}
                        disabled={isDisabled || isLoading}
                        onClick={() => onCancelOrder(order!, nft)}
                      >
                        {t('cancel_sale_page.submit')}
                      </Button>
                    </div>
                  </AssetAction>
                )
              }}
            </AssetProviderPage>
          )}
        </Wallet>
      </Page>
      <Footer />
    </>
  )
}

export default memo(CancelSalePage)
